import React, { useState } from 'react';
import './TeamGallery.css';

import { Heading, PageTitle } from '../../../components';
import { teamGallery } from '../../../constants';

import { FaPlus } from 'react-icons/fa';

import Lightbox from "react-18-image-lightbox";
import "react-18-image-lightbox/style.css";

const TeamGallery = () => {

    // State to track the index of the currently displayed image in the lightbox
    const [index, setIndex] = useState(-1);

    // Get the current image based on the selected index
    const currentImage = teamGallery[index];

    // Calculate the index of the next image
    const nextIndex = (index + 1) % teamGallery.length;
    const nextImage = teamGallery[nextIndex] || currentImage;

    // Calculate the index of the previous image
    const prevIndex = (index + teamGallery.length - 1) % teamGallery.length;
    const prevImage = teamGallery[prevIndex] || currentImage;

    // Function to open the lightbox with the selected image
    const openLightbox = (index) => setIndex(index);

    // Function to close the lightbox
    const closeLightbox = () => setIndex(-1);

    // Function to navigate to the previous image in the lightbox
    const handleMovePrev = () => setIndex(prevIndex);

    // Function to navigate to the next image in the lightbox
    const handleMoveNext = () => setIndex(nextIndex);

    return (
        <>
            {/* Page Title */}
            <PageTitle title={'Galeria z Rady Naukowej'} page={'Galeria'} />

            <section className='team-gallery-section'>

                {/* Section heading */}
                <Heading title={'Galeria'} subTitle={'Zobacz galerie zdjęć z Rady naukowej'} />

                <div className='team-gallery-grid'>

                    {/* Render galleryPartners images */}
                    {teamGallery.map((item, index) => {
                        return (
                            <div key={index} className={`team-gallery-card team-gallery-item-${index + 1}`}>
                                {/* Gallery image */}
                                <img src={item} alt='' />
                                <div className="team-gallery-overlay">
                                    {/* Button to open lightbox */}
                                    <button onClick={() => openLightbox(index)}>
                                        <FaPlus className='team-gallery-icon' />
                                    </button>
                                </div>
                            </div>
                        );
                    })}

                    {/* Render lightbox only when an image is selected */}
                    {index !== -1 && (
                        <Lightbox
                            mainSrc={currentImage} 
                            mainSrcThumbnail={currentImage} 
                            nextSrc={nextImage} 
                            nextSrcThumbnail={nextImage} 
                            prevSrc={prevImage} 
                            prevSrcThumbnail={prevImage} 
                            onCloseRequest={closeLightbox} 
                            onMovePrevRequest={handleMovePrev} 
                            onMoveNextRequest={handleMoveNext} 
                        />
                    )}

                </div>

            </section>

        </>
    );
};

export default TeamGallery;